<template>
  <div
    :class="
      `course-content-body-header ht-55 bd-b d-flex d-flex-row align-items-center justify-content-between ${
        $store.state.app.skin.dark ? '' : 'bg-white'
      } `
    "
  >
    <div class="d-flex align-items-center">
      <div
        @click="$emit('on-toggle-nav')"
        class="pd-y-15 pd-x-20 tx-color-02"
        role="button"
      >
        <feather type="menu"></feather>
      </div>
      <div v-if="teacher.has">
        <router-link :to="`/lms/courseView/${courseId}/${teacher.boxId}/0/396`">
          <div class="d-flex align-items-center">
            <img
              :src="teacher.cover"
              class="wd-30 rounded-circle mg-r-15"
              alt=""
            />
            <div>
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                {{ teacher.firstName }}
              </h6>
              <span class="d-block tx-11 text-muted">{{
                teacher.position
              }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="mg-l-20 pd-l-10 bd-l d-flex align-items-center">
      <router-link :to="`/lms/courseView/${course.id}/0/0/0`">
        <div class="d-flex align-items-center">
          <feather type="home" class="ht-20-f wd-20-f"></feather>
          <div class="mg-l-10">
            <h6 class="tx-13 tx-inverse tx-semibold mg-b-5">
              {{ course.name }}
            </h6>
            <div class="progress ht-5 wd-200">
              <div
                class="progress-bar wd-25p"
                :style="`width: ${course.percent}%`"
                role="progressbar"
              ></div>
            </div>
          </div>
        </div>
      </router-link>
      <task-rating
        class="mg-l-10 pd-l-10 bd-l"
        :taskId.sync="course.id"
        :disabled="course.percent < 100"
        :score="
          course.myRate != undefined && course.myRate != null
            ? course.myRate
            : 0
        "
        :allowHalf="true"
        @on-rated="course.myRate = $event"
      />
    </div>
    <div class="mg-l-auto d-flex pd-r-10">
      <div
        @click="
          $emit('on-toggle-content', $store.state.app.mainLayoutConfig.expanded)
        "
        v-if="$route.name == 'lmsLessonView'"
        role="button"
        class="mg-l-20"
      >
        <feather
          :type="
            $store.state.app.mainLayoutConfig.expanded ? 'minimize' : 'maximize'
          "
          class="wd-20-f ht-20-f tx-color-02"
        ></feather>
      </div>
      <div
        v-if="rdy && course.i5 == 1 && $route.params.bot != 416"
        @click="$emit('on-toggle-right-side')"
        role="button"
        class="mg-l-20 text-uppercase"
      >
        <span v-if="$route.params.bot == 493 && !showRightSide">Чат</span>
        <feather
          :type="showRightSide ? 'chevron-right' : 'chevron-left'"
          class="wd-20-f ht-20-f"
        ></feather>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    taskRating: () => ({
      component: import("@/components/task/components/actions/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    course: {
      type: Object,
      default: () => {}
    },
    showRightSide: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      teacher: {
        has: false
      },
      courseId: null,
      rdy: true
    };
  },
  mounted() {
    //let courseId = 0;
    if (this.$route.name == "lmsCourseView") {
      this.courseId = this.$route.params.id;
    } else if (this.$route.name == "lmsLessonView") {
      this.courseId = this.$route.params.cid;
    }

    if (this.course.teachers.length > 0) {
      //console.log('this.course.teachers[0];', this.course.teachers[0]);
      this.teacher = this.course.teachers[0];
      this.teacher.has = true;
    }

    // request({
    //   api: { method: "get", url: "v2/learn/courseinfo" },
    //   params: { id: courseId },
    //   store: this.$store,
    // }).then((res) => {
    //   console.log('v2/learn/courseinfo=> ', res);
    //   if (res != false) {
    //     this.course = res.data.course;
    //     this.$emit('on-course-info', this.course);
    //     if (res.data.course.teachers.length > 0) {
    //       this.teacher = res.data.course.teachers[0];
    //       this.teacher.has = true;
    //     }
    //     this.rdy = true;
    //   }
    // });
  }
};
</script>
